export default __webpack_public_path__ + "static/media/priority_active_icon.d2021344.svg";